import { useMemo } from 'react';
import { useRootSelector } from './root-selector.hook';
import { useTestingTagContext } from './testing-tag-context.hook';

export const useTestId = () => {
    const { tag } = useTestingTagContext();
    const pathname = useRootSelector(state => state.router.location.pathname);
    const testId = useMemo(() => {
        return `${tag}--${pathname}`;
    }, [pathname, tag]);

    return testId;
};
